import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'CommentForm',
};

import { useContext, useStore, useRoute, computed, ref } from '@nuxtjs/composition-api';
import { State } from '@/store';

interface CommentParams {
  id: number | null;
  type: string;
  comment: string;
  parent: number | null;
}

interface Props {
  resourceId?: number | null;
  parent?: number | null;
  type?: string;
  replyingTo?: string;
  layout?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    resourceId: { default: null },
    parent: { default: null },
    type: { default: 'comment' },
    replyingTo: { default: '' },
    layout: { default: 'default' }
  },
  setup(__props: any) {

const props = __props as { resourceId: number | null, parent: number | null, type: string, replyingTo: string, layout: string };

const { $intercom, $mzAnalyticsApi } = useContext();
const $store = useStore<State>();
const $route = useRoute();



const comment = ref<string>('');
const addingComment = ref<boolean>(false);
const error = ref<string>();
const success = ref<string>();

const isAuthenticated = computed(() => $store.getters.isAuthenticated);
const loggedInUser = computed(() => $store.getters.loggedInUser);
const resource = computed(() => $store.getters.resource);

// Listen for success and error callbacks
if ($route.value.query.commented) {
  success.value = $route.value.query.commented as string;
}

if ($route.value.query.comment_error) {
  error.value = $route.value.query.comment_error as string;
}

const addComment = async () => {
  if (!comment.value || !props.resourceId) {
    return;
  }

  addingComment.value = true;

  let params = {
    id: props.resourceId,
    type: props.type,
    comment: comment.value,
  } as CommentParams;

  if (props.parent) {
    params = { ...params, parent: props.parent };
  }

  try {
    const commentId = await $store.dispatch('addComment', params);

    comment.value = ''; // reset comment field to empty

    eventCommentAdded(commentId);

    await $store.dispatch('setToast', {
      type: 'success',
      content: 'Comment added.',
      icon: 'check',
      dismiss: true,
    });
  } catch (err) {
    error.value = err as string;
  } finally {
    addingComment.value = false;
  }
};

const toggleLoginModal = (show: boolean) => $store.dispatch('toggleLoginModal', show);

const eventCommentAdded = (commentId: number) => {
  if (!resource.value.event_params) {
    return;
  }

  const eventType = resource.value.event_params.Resource_Type_Name ? 'Resource' : 'Content';
  const commentParams = {
    Feedback_Type_Name: 'Comment',
    Comment_Parent_Id: props.parent,
  };

  const commentParamsIntercom = {
    postTitle: resource.value.event_params.Page_Name,
    postUrl: resource.value.event_params.Page_Url,
    postId: props.resourceId,
    commentId,
    action_type_name: 'Comment Posted',
  };

  let pageType = resource.value.type
    .trim()
    .replace(/[\s-]+/g, '_')
    .toLowerCase();
  let productAreas = '';
  if (pageType === 'teaching_resource') {
    pageType = 'resource';
    productAreas = 'resources';
  } else if (pageType === 'unit_plan') {
    productAreas = 'unit_plan';
  } else if (pageType === 'blog') {
    productAreas = 'content';
  } else if (pageType === 'podcast') {
    productAreas = 'content';
  } else if (pageType === 'resource_pack') {
    pageType = 'pack';
    productAreas = 'pack';
  } else if (pageType === 'widget') {
    productAreas = 'widget';
  }
  const analyticsName = `${pageType}.comments.add_your_comment`;
  $mzAnalyticsApi({
    event: 'click',
    name: analyticsName,
    productArea: productAreas,
    entityType: pageType,
    entityId: resource.value.id,
  });

  if (typeof $intercom !== 'undefined') {
    $intercom.trackEvent('Comment Posted', commentParamsIntercom);
  }
};

return { __sfc: true,$intercom, $mzAnalyticsApi, $store, $route, props, comment, addingComment, error, success, isAuthenticated, loggedInUser, resource, addComment, toggleLoginModal, eventCommentAdded }
}

})